module.exports = __webpack_public_path__ + "static/media/Flexpoli-350x210.51ff850c.png";